import { render, staticRenderFns } from "./feedbackResult.vue?vue&type=template&id=70d493b1&scoped=true"
import script from "./feedbackResult.vue?vue&type=script&lang=js"
export * from "./feedbackResult.vue?vue&type=script&lang=js"
import style0 from "./feedbackResult.vue?vue&type=style&index=0&id=70d493b1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d493b1",
  null
  
)

export default component.exports